// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"610228cd","320":"bb6fcb72","453":"0f5479b8","667":"b3de8b79","905":"9dcde78f"}[chunkId] + ".chunk.js";
};